/* eslint-disable no-unused-vars */
import React, { Component } from "react";
import OnetoOneView from "./components/onetooneview/OnetoOneView";
import OnDemandPlaying from "./components/ondemandplaying/OnDemandPlaying";

import agoraElectron from "./agora-electron2";
import virtualPlaying from "./virtual-playing";
import ondemandCamera from "./ondemand-camera";

import audioPlay from "./audioPlay";
import AppRoutes from "./components/self-assesment/routes";
import { AssessmentProvider } from "./components/self-assesment/AssessmentContext";
import { ProgressProvider } from "./components/self-assesment/progressContext";
import MyraAgent from "./components/voice-agent/MyraAgent";
import { InactivityModalManager, RestartPopup, MicPermissionModal, AnalyticsService } from "./components/self-assesment/SelfAssesment";

import RecoveryService from './services/CrashRecoveryService';
// import WakeLockManager from "../src/components/self-assesment/WakeLockManager";
import GSAExitHandler from "./components/self-assesment/GSAExitHandler";
import SelfAssessment2 from "./components/self-assesment2/SelfAssessment";
import { HomeScreen } from "./components/self-assesment2/HomeScreen"
import { BrowserRouter } from "react-router-dom";
import AppRoutesV2 from "./components/self-assesment2/routes";
// const wakeLock = new WakeLockManager({
//   onReminderPreferenceChange: (shouldRemind) => {
//     localStorage.setItem('wakelock_remind', JSON.stringify(shouldRemind));
//   }
// });

// wakeLock.acquire = async function () {
//   console.log("WakeLockManager: Forced fallback modal for testing");
//   this._showFallbackModal();
//   return false;
// };

// window.wakeLockManager = wakeLock;
window.AnalyticsService = AnalyticsService

const cameraInstance = new ondemandCamera();
window.ondemandCameraInstance = cameraInstance;

const isElectron = window.isElectron === true || window.isElectron || window["electron"];
const isDeepOpen = !!window.savedDeeplink;

window.checkIsSelf = () => {
  const loadSelf = localStorage.getItem("loadSelf");
  if (loadSelf && window.loadedROM) {
    return JSON.stringify(window.loadedROM);
  }
  return "no";
};

window.cameFromGsaV2 = () => {
  return localStorage.getItem("cameFromGsaV2") === "true";
};

window.getNoCameraMode = () => {
  return localStorage.getItem("noCameraMode") === "true";
};

window.optionSelected = false;

window.audioPlayer = new audioPlay();

new agoraElectron().listenNative();
new virtualPlaying().listenNative();
new ondemandCamera().listenNative();
window.audioPlayer.listenNative();

window.openPopupNative = (url) => {
  window.open(url, "Read", "top=50,left=50,toolbar=false,menubar=false,nodeIntegration=no");
};



class App extends Component {
  state = {
    hideAssessmentElm: window.disableHomeScreen === true,
    isLoading: false,
    showGlobalGSAExitHandler: false,
    globalGsaStep: "Movement_test",
    optionSelected: false,
  };

  componentDidMount() {
    window.setHideElementsElm = (value) => {
      window.disableHomeScreen = value;
      this.setState({ hideAssessmentElm: value });
    };



    window.openGSAExitHandler = ({ gsaStep = "movement_test_1" } = {}) => {
      console.log("window.openGSAExitHandler called with:", gsaStep);
      window.optionSelected = false;
      window.resumeNoCamera = false;
      if (window.VoiceService) {
        window.VoiceService.stopAgentSpeech()
        window.VoiceService.stopAllVoiceActivity()
      }
      if (window.videoController) {
        window.videoController.pause();
      }

      this.setState({
        showGlobalGSAExitHandler: true,
        globalGsaStep: gsaStep,
      });
    };

    window.closeGSAExitHandler = () => {
      const shouldResumeNoCamera = window.getNoCameraMode?.() && window.optionSelected === false;
      this.setState({ showGlobalGSAExitHandler: false });
      console.log("window.resumeNoCamera is : ", window.resumeNoCamera);
      if (shouldResumeNoCamera && typeof window.resumeNoCameraFromExit === "function") {
        console.log("[GSA_EXIT] invoking resumeNoCameraFromExit from window.closeGSAExitHandler");
        window.resumeNoCameraFromExit();
      }
    };

    console.log("App: Page fully loaded. Checking for crash recovery...");

    if (RecoveryService.wasLastSessionCrash()) {
      console.warn("App: Crash detected. Triggering auto-login...");
      this.setState({ isLoading: true }); // Show Loader
      setTimeout(() => {
        console.log("App: 5s delay finished. Triggering auto-login now.");
        sessionStorage.setItem("didCrash", "true");
        this.setState({ isLoading: false }, () => {
          this.triggerMemberLogin();
        });

        // this.setState({ isLoading: true }); // Show Loader
      }, 3000);
    }
    // }

    // Safari & iOS: 'pagehide' is the most reliable event
    window.addEventListener("pagehide", RecoveryService.handleIntentionalExit);

    // Chrome, Edge, Firefox: 'beforeunload' is the standard
    window.addEventListener("beforeunload", RecoveryService.handleIntentionalExit);

    this.handleVisibility = () => {
      if (document.hidden === true) {
        RecoveryService.stopStressTest();

        if (window.trackFlutterEvent) {
          window.trackFlutterEvent(JSON.stringify({
            event_name: "app_backgrounded",
            event_timestamp: new Date().toISOString(),
          }));
        }
      } else {
        if (window.trackFlutterEvent) {
          window.trackFlutterEvent(JSON.stringify({
            event_name: "app_foregrounded",
            event_timestamp: new Date().toISOString(),
          }));
        }
      }
    };

    document.addEventListener("visibilitychange", this.handleVisibility);
  }

  componentWillUnmount() {
    RecoveryService.stopHeartbeat(true);
    document.removeEventListener("visibilitychange", this.handleVisibility);


    window.openGSAExitHandler = null;
    window.closeGSAExitHandler = null;
  }


  closeGlobalGSAExitHandler = () => {
    const shouldResumeNoCamera = window.getNoCameraMode?.() && window.optionSelected === false;
    this.setState({ showGlobalGSAExitHandler: false });
    if (shouldResumeNoCamera && typeof window.resumeNoCameraFromExit === "function") {
      console.log("[GSA_EXIT] invoking resumeNoCameraFromExit from closeGlobalGSAExitHandler");
      window.resumeNoCameraFromExit();
    }
    window.resumeNoCamera = false;
  };


  handleGlobalGSAExit = () => {
    window.location.replace(window.location.origin);
  };


  handleGlobalOpenMyraChat = (msg) => {
    this.setState({ showGlobalGSAExitHandler: false });
    window.initFromUserGesture();
    if (window.audioPlayer && window.audioPlayer.pcm) {
      // Stoping the any ongoing PCM playback
      if (typeof window.audioPlayer.ttsPcmAbort === "function") {
        window.audioPlayer.ttsPcmAbort();
      }
      // Force reset state
      window.audioPlayer.pcm.active = false;
      window.audioPlayer.pcm.queuedSamples = 0;
      window.audioPlayer.pcm.endReceived = false;
      window.audioPlayer.pcm.floatQueue = [];
      window.audioPlayer.pcm.floatQueueSamples = 0;
      window.audioPlayer.pcm.sources.clear();
    }

    if (window.MyraInteraction) {
      window.MyraInteraction.closeVoice();
      window.MyraInteraction.closeChat();

      setTimeout(() => {
        if (window.MyraInteraction.getMode() !== "chat") {
          window.MyraInteraction.pickChat();
          window.MyraInteraction.onMyraMessage(msg);
        } else {
          window.MyraInteraction.openChat();
          window.MyraInteraction.onMyraMessage(msg);
        }
      }, 100);
    }
  };

  handleGlobalOpenMyraVoice = async (msg) => {
    this.setState({ showGlobalGSAExitHandler: false });
    window.initFromUserGesture();
    if (window.audioPlayer && window.audioPlayer.pcm) {
      // Stoping the any ongoing PCM playback
      if (typeof window.audioPlayer.ttsPcmAbort === "function") {
        window.audioPlayer.ttsPcmAbort();
      }
      // Force reset state
      window.audioPlayer.pcm.active = false;
      window.audioPlayer.pcm.queuedSamples = 0;
      window.audioPlayer.pcm.endReceived = false;
      window.audioPlayer.pcm.floatQueue = [];
      window.audioPlayer.pcm.floatQueueSamples = 0;
      window.audioPlayer.pcm.sources.clear();
    }
    const flowToStart = window.VoiceService._currentFlow || window.currentFlow;
    const userName = localStorage.getItem("self_name");
    const granted = await window.requestMicrophonePermission({
      onGrant: () => {
        window.MyraInteraction.pickVoice();
        window.MyraInteraction.openVoice();
        window.VoiceService.startFlowWithoutAnnouncement(flowToStart, userName, msg);
      },
      onDeny: () => {
        console.log("[MyraAgent] User denied mic - switching to chat");
        window.MyraInteraction.closeVoice();
        window.MyraInteraction.switchMode("chat");

        setTimeout(() => {
          window.VoiceService.startFlowWithoutAnnouncement(flowToStart);
          let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
          window.MyraInteraction.pickChat();
          window.MyraInteraction.openChat();
          window.MyraInteraction.onMyraMessage(msg);
        }, 100);
      },
    });
  };

  handleGlobalSetCommMode = (mode) => {
    if (!window.MyraInteraction) return;

    if (mode === "chat") {
      window.MyraInteraction.pickChat();
    } else if (mode === "voice") {
      window.MyraInteraction.pickVoice();
    }
  };

  handleGlobalAnalyticsEvent = (event) => {
    console.log("Global GSA Exit Analytics event:", event);

    if (AnalyticsService?.trackStep) {
      AnalyticsService.trackStep(event);
    }
  };

  triggerMemberLogin = () => {
    if (window.preloadAllAudios) {
      window.preloadAllAudios();
    }
    if (window.videoUnlockPlay) {
      window.videoUnlockPlay();
    }

    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";

      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";

      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");

      document.querySelector("html").classList = [];

      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  }

  render() {
    const hideAssessmentElm = window.disableHomeScreen === true;
    const { isLoading, showGlobalGSAExitHandler, globalGsaStep } = this.state;
    const params = new URLSearchParams(window.location.search);
    const gsaVersion = params.get("gsa") || localStorage.getItem("gsa_version") || "v1";
	const isVirdioDomain = ["virdiohealth.com", "www.virdiohealth.com"].includes(window.location.host);
	
    let isV2 = gsaVersion === "v2";
	
	if ( isVirdioDomain ) { isV2 = false; localStorage.removeItem("isV2"); } else { isV2 = true; localStorage.setItem('isV2', 'true'); } 

    return (
      <div className="App">
        {isLoading && (
          <div className="overlay-loader">
            <div className="spinner" />
            <span>Restoring your session…</span>
          </div>
        )}

        <RestartPopup />
        <MyraAgent />
        {/* ========== NEW: Add Modal Manager ========== */}
        <InactivityModalManager />
        <MicPermissionModal />

        <GSAExitHandler
          isOpen={showGlobalGSAExitHandler}
          gsaStep={globalGsaStep}
          commMode={window.MyraInteraction?.getMode() || null}
          onClose={this.closeGlobalGSAExitHandler}
          onExit={this.handleGlobalGSAExit}
          onOpenMyraChat={this.handleGlobalOpenMyraChat}
          onOpenMyraVoice={this.handleGlobalOpenMyraVoice}
          onSetCommMode={this.handleGlobalSetCommMode}
          onAnalyticsEvent={this.handleGlobalAnalyticsEvent}
        />

        <div id="assesmentDiv" className={isDeepOpen ? "hide" : ""}>
          {/* {!hideAssessmentElm && (
            <AssessmentProvider>
              <ProgressProvider>{!isElectron && <SelfAssessment2 />}</ProgressProvider>
            </AssessmentProvider>
          )} */}
          <AssessmentProvider>
            <ProgressProvider>
              {!isElectron && (
                isV2 ? <>
                  <>
                    {localStorage.setItem('isV2', 'true')}
                    {/* <BrowserRouter>
                      <HomeScreen />
                    </BrowserRouter> */}
                    <AppRoutesV2 />
                  </>
                </> : <>
                  {localStorage.removeItem("isV2")}
                  <AppRoutes />
                </>
              )}
            </ProgressProvider>
          </AssessmentProvider>
        </div>
        <OnetoOneView />
        <OnDemandPlaying />
      </div>
    );
  }
}
export default App;
